// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2ojy5","buttons":"PendingPaymentAlert_buttons__nviWE"};